/**
 * Service de traduction et vulgarisation des messages d'erreur
 * Transforme les messages techniques du backend en messages compréhensibles pour les utilisateurs
 */

import { extractErrorMessage } from "./helpers/errorExtractionHelpers";
import { mapNotaryBusinessApiUserMessage } from "./helpers/notaryBusinessApiMessageResolve";
import { userFriendlyErrorFromExternalServiceApiCode } from "./constants/externalServiceErrorPatterns";
import { applyRequestIdCorrelation } from "./helpers/serverErrorReferenceHelpers";
import { humanizeError } from "./humanizeError";
import type { UserFriendlyError } from "./types";

export type { UserFriendlyError, ErrorResponse, HttpErrorPayload } from "./types";
export type { ExtractedErrorMessage } from "./helpers/errorExtractionHelpers";
export { extractErrorMessage } from "./helpers/errorExtractionHelpers";
export { mapNotaryBusinessApiUserMessage } from "./helpers/notaryBusinessApiMessageResolve";
export { humanizeError } from "./humanizeError";

/**
 * Fonction principale pour obtenir un message d'erreur humanisé
 */
export function getUserFriendlyError(error: unknown): UserFriendlyError {
	const { message, status, code, requestId } = extractErrorMessage(error);
	const fromCatalog = mapNotaryBusinessApiUserMessage(code) ?? mapNotaryBusinessApiUserMessage(message);
	if (fromCatalog) {
		return {
			title: "Action impossible",
			message: fromCatalog,
			canRetry: false,
		};
	}
	const fromExternalCode = userFriendlyErrorFromExternalServiceApiCode(code);
	if (fromExternalCode) {
		return fromExternalCode;
	}
	const friendly = humanizeError(message, status ?? undefined);
	return applyRequestIdCorrelation(friendly, requestId, status);
}
